import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import moment from '../../../lib/moment.js'
import {
  Container,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
} from 'reactstrap'
import DatePicker from 'react-datepicker'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import {
  modalAction,
  authAction,
  reportAction,
} from './../../../actions/'
import {
  modalSelector,
  authSelector,
  reportSelector,
} from './../../../selectors'
import Searchbar from '../../../components/searchbar-report/audit-log'
import ActiveUsersChart from '../../../components/report-active-users-chart'
import withLayout from '../../../helpers/withLayout'
import { FONTS, COLORS } from '../../../constants'

class AuditLogReport extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getActiveUsersData.activeUserReport')) {
      const key = []
      const value = []
      Object.keys(get(nextProps, 'getActiveUsersData.activeUserReport.activeUserCounts')).sort().map(d => {
        key.push(d.substring(d.length - 2))
        value.push(get(nextProps, 'getActiveUsersData.activeUserReport.activeUserCounts')[d])
        return d
      })
      set(tempState, 'active_users', { key, value })
      set(tempState, 'meta', get(nextProps, 'getActiveUsersData.meta'))
      nextProps.resetGetActiveUsers()
    }
    if (get(nextProps, 'exportActiveUsersData')) {
      window.open(get(nextProps, 'exportActiveUsersData'))
      nextProps.resetExportActiveUsers()
    }
    if (get(nextProps, 'exportAuditLogsData')) {
      window.open(get(nextProps, 'exportAuditLogsData'))
      nextProps.resetExportAuditLogs()
    }
    return tempState
  }

  constructor(props) {
    super(props)
    this.state = {
      active_users: [],
      meta: null,
      moment: moment(),
      export: null,
      start_date_export: moment().startOf('month'),
      end_date_export: moment().endOf('month'),
    }
    this.onMonthChange = this.onMonthChange.bind(this)
    this.left = this.left.bind(this)
    this.right = this.right.bind(this)
    this.today = this.today.bind(this)
    this.exportActiveUsers = this.exportActiveUsers.bind(this)
    this.exportAuditLogs = this.exportAuditLogs.bind(this)
    this.export = this.export.bind(this)
    this.handleStartDateExport = this.handleStartDateExport.bind(this)
    this.handleEndDateExport = this.handleEndDateExport.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getActiveUsers(moment().format('YYYY-MM-01'), moment().endOf('month').format('YYYY-MM-DD'), access_token)
  }

  onMonthChange(_moment) {
    this.setState({ moment: _moment })
  }

  today() {
    this.set(moment())
  }

  left() {
    this.set(moment(this.state.moment.add(-1, 'month')))
  }

  right() {
    this.set(moment(this.state.moment.add(1, 'month')))
  }

  set(_moment) {
    this.setState({
      moment: _moment,
      start_date_export: _moment.startOf('month'),
      end_date_export: _moment.clone().endOf('month'),
    })
    this.onMonthChange(_moment)
    const access_token = localStorage.getItem('access_token')
    const start_date = this.state.moment.startOf('month')
    const end_date = this.state.moment.endOf('month')
    this.props.getActiveUsers(start_date.format('YYYY-MM-01'), end_date.format('YYYY-MM-DD'), access_token)
  }

  handleStartDateExport(date) {
    this.setState({ start_date_export: date })
  }

  handleEndDateExport(date) {
    this.setState({ end_date_export: date })
  }

  exportActiveUsers() {
    const { start_date_export, end_date_export } = this.state
    const access_token = localStorage.getItem('access_token')
    this.props.exportActiveUsers(start_date_export, end_date_export, access_token)
    this.props.hideModal('export')
    this.setState({
      start_date_export: moment().startOf('month'),
      end_date_export: moment().endOf('month'),
    })
  }

  exportAuditLogs() {
    const { start_date_export, end_date_export } = this.state
    const access_token = localStorage.getItem('access_token')
    this.props.exportAuditLogs(start_date_export, end_date_export, access_token)
    this.props.hideModal('export')
    this.setState({
      start_date_export: moment().startOf('month'),
      end_date_export: moment().endOf('month'),
    })
  }

  export(exp) {
    this.setState({ export: exp })
    this.props.showModal('export')
  }

  render() {
    const isFetching = get(this.props, 'getIsFetching')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsHRUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsLOBLeadUser = get(this.props, 'authData.user.is_lob_lead_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
      || get(this.props, 'redirectReport.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectReport.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    if (IsLOBLeadUser !== undefined &&
      IsHRUser !== undefined &&
      IsHRConfidentialUser !== undefined &&
      IsManagementUser !== undefined &&
      IsSystemUser !== undefined &&
      !(IsSystemUser || IsLOBLeadUser || IsHRUser || IsHRConfidentialUser || IsManagementUser)) window.location = '/home'
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          { ...this.state }
          export={ this.export }
        />
        <Modal
          isOpen={ get(this.props, 'modalType') === 'export' }
          toggle={ () => this.props.hideModal('export') }
        >
          <ModalHeader toggle={ () => this.props.hideModal('export') }>
            <HeadLabel>Export</HeadLabel>
          </ModalHeader>
          <ModalBody>
            <TextExport>Select Date</TextExport>
            <DatePickerWrapper>
              <ExportDatePicker
                autoComplete='off'
                onChange={ this.handleStartDateExport }
                placeholderText='DD/MM/YYYY'
                selected={ this.state.start_date_export }
                dateFormat="DD/MM/YYYY"
                showYearDropdown
                showMonthDropdown
              />
              &nbsp;-&nbsp;
              <ExportDatePicker
                autoComplete='off'
                onChange={ this.handleEndDateExport }
                placeholderText='DD/MM/YYYY'
                selected={ this.state.end_date_export }
                dateFormat="DD/MM/YYYY"
                showYearDropdown
                showMonthDropdown
              />
            </DatePickerWrapper>
          </ModalBody>
          <ModalFooter>
            <CustomButton
              color="success"
              onClick={ this.state.export === 0 ? this.exportAuditLogs : this.exportActiveUsers }
            >Export</CustomButton>
          </ModalFooter>
        </Modal>
        <div style={ { width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'stretch', paddingRight: '10px', paddingLeft: '10px' } }>
          <DivSummarystatus>
            <RowStatus>
              <ColStatus>
                <Row>
                  <NumberText>
                    &nbsp; {`${get(this.state, 'meta.today', '')}`}
                  </NumberText>
                  <Text>&nbsp;active users</Text>
                </Row>
                <Row><TextNumberOfYear>Today</TextNumberOfYear></Row>
              </ColStatus>
              <Divider />
              <ColStatus>
                <Row>
                  <NumberText>
                    &nbsp; {`${get(this.state, 'meta.yesterday', '')}`}
                  </NumberText>
                  <Text>&nbsp;&nbsp;active users</Text>
                </Row>
                <Row><TextNumberOfYear>Yesterday</TextNumberOfYear></Row>
              </ColStatus>
              <Divider />
              <ColStatus>
                <Row>
                  <NumberText>
                    &nbsp; {`${get(this.state, 'meta.this_week', '')}`}
                  </NumberText>
                  <Text>&nbsp;&nbsp;active users</Text>
                </Row>
                <Row><TextNumberOfYear>In This Week</TextNumberOfYear></Row>
              </ColStatus>
              <Divider />
              <ColStatus>
                <Row>
                  <NumberText>
                    &nbsp; {`${get(this.state, 'meta.this_month', '')}`}
                  </NumberText>
                  <Text>&nbsp;&nbsp;active users</Text>
                </Row>
                <Row>
                  <TextNumberOfYear>In This Month</TextNumberOfYear>
                </Row>
              </ColStatus>
            </RowStatus>
          </DivSummarystatus>
          <DivSummary>
            <RowStatus>
              <ColStatus>
                <Row>
                  <NumberText>
                    &nbsp;&nbsp;{`${get(this.state, 'meta.highest.count', '')}`} users&nbsp;&nbsp;&nbsp;{`${moment(get(this.state, 'meta.highest.date', '')).format('DD MMMM YYYY')}`}
                  </NumberText>
                </Row>
                <Row><TextNumberOfYear>Highest Daily Active Users</TextNumberOfYear></Row>
              </ColStatus>
            </RowStatus>
          </DivSummary>
        </div>
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <ActiveUsersChart
          left={ this.left }
          right={ this.right }
          { ...this.state }
        />
      </Wrapper>
    )
  }
}
AuditLogReport.propTypes = {
  getAuth: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  getYearOfService: PropTypes.func.isRequired,
  getCompany: PropTypes.func.isRequired,
  getLOB: PropTypes.func.isRequired,
  getActiveUsers: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
  exportActiveUsers: PropTypes.func.isRequired,
  exportAuditLogs: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectReport: reportSelector.redirectReport,
  getActiveUsersData: reportSelector.getActiveUsersData,
  getIsFetching: reportSelector.getIsFetching,
  exportActiveUsersData: reportSelector.exportActiveUsersData,
  exportAuditLogsData: reportSelector.exportAuditLogsData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getActiveUsers: reportAction.getActiveUsersReport,
  resetGetActiveUsers: reportAction.resetGetActiveUsersReport,
  exportActiveUsers: reportAction.exportActiveUsersReport,
  resetExportActiveUsers: reportAction.resetExportActiveUsersReport,
  exportAuditLogs: reportAction.exportAuditLogsReport,
  resetExportAuditLogs: reportAction.resetExportAuditLogsReport,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(withLayout(AuditLogReport))

const Wrapper = styled(Container)`
  width: 100%;
  padding: 0px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`
const DivSummary = styled.div`
  background-color: #FFFFFF;
  text-align: center;
  height: 100px;
  width: 60%;
  margin-top: 1%;
  margin-bottom: 1%;
  flex-grow: 1;
  -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0,0.16);
  -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
`
const DivSummarystatus = styled.div`
  background-color: #FFFFFF;
  text-align: center;
  height: 100px;
  width:100%;
  margin-top: 1%;
  margin-bottom: 1%;
  margin-right: 1%;
  flex-grow: 1;
  -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0,0.16);
  -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
`
const Text = styled.label`
  font-family: ${FONTS.GOTHAM} !important;
  color: ${COLORS.PRIMARY_RED};
  font-size: ${FONTS.NORMAL_SIZE};
  margin-top: 5px;
`
const NumberText = styled.label`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  color: ${COLORS.PRIMARY_RED};
  font-size: ${FONTS.HEADER_SIZE};
  margin-bottom: 0px;
  padding-left: 10px;
`
const TextNumberOfYear = styled.label`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  padding-left: 25px;
  margin-bottom: 0px;
  color: #333333;
`
const Divider = styled.p`
  height: 80px;
  width: 1px;
  border-left: 1px solid #FFFFFF;
`
const HeadLabel = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
`
const RowStatus = styled(Row)`
  padding-top: 1%;
  padding-bottom: 1%;
  width: 100%;
  margin: auto;
`
const ColStatus = styled(Col)`
  height: 100%;
  align-self: center;
  align-self: stretch;
  padding-top: 10px;
  @media only screen and (max-width: 1366px) {
    padding-right: 2%;
    padding-left: 3%;
  }
`
const TextExport = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const DatePickerWrapper = styled.div`
  display: flex;
  align-items: center;
`
const ExportDatePicker = styled(DatePicker)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  width: 200px;
  height : 45px ;
  padding-left: 5%;
  border-radius: 5px;
  border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
  @media only screen and (max-width: 1440px) {
    width: 200px;
  }
  @media only screen and (max-width: 1024px) {
    width: 150px;
  }
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`



// WEBPACK FOOTER //
// ./src/pages/report/audit-log/index.js